<template>
  <div>
    <div class="relative">
      <el-form :model="form" ref="form" label-width="80px" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <div>
            <div v-for="(item,i) in form.groupList" :key="'groupList'+i" style="margin-top: 20px;">
              <div class="absolute right" style="right: 30px;width: 60px;z-index: 3;">
                <i v-if="i==form.groupList.length-1 && form.groupList.length<5" class="icon icon_add-circle pointer" @click="addGroup(i)" style="font-size: 30px;"></i>
                <i v-if="form.groupList.length>1" class="icon icon_minus-circle pointer" @click="delGroup(i)" style="font-size: 30px;"></i>
              </div>
              <el-form-item :label="i>0?'':'教材名称'" :prop="'groupList.'+i+'.groupName'" style="margin-right:10px;" :rules="[$validate.string(20)]">
                <el-input v-model="item.groupName" :maxlength="20" placeholder="请输入" style="width: 260px;"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {
        groupList: [{}]
      }
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async addGroup (i) {
      let isOK = await this.Tool.checkForm(this.$refs['form'], [`groupList.${i}.groupName`])
      if (isOK) {
        this.form.groupList.splice(Number(i) + 1, 0, {})
      }
    },
    delGroup (i) {
      this.form.groupList.splice(i, 1)
    },
    async initForm () {
      if (this.row) {
        // let info = JSON.parse(JSON.stringify(this.row))
        // this.form = info
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let info = this.form
        this.$message({ type: 'success', message: '保存成功' })
        this.$emit('close', info)
      }
    }
  }
}
</script>
